import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAlert } from '../context/AlertContext';
import '../styles/BuscarReservacion.css';

const BuscarReservacion = ({ rutaDestino }) => {
  const [folio, setFolio] = useState('');
  const { mostrarAlerta } = useAlert();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setFolio(e.target.value);
  };

  const handleSearch = () => {
    if (folio.trim()) {
      navigate(`/${rutaDestino}/${folio}`);
    } else {
      mostrarAlerta('Por favor, ingresa un folio válido.','error');
    }
  };

  return (
    <div className="buscar-reservacion-container">
      <h2>Buscar Reservación</h2>
      <div className="buscar-reservacion-form">
        <input
          type="text"
          placeholder="Ingresa el folio"
          value={folio}
          onChange={handleInputChange}
          className="buscar-input"
        />
        <motion.button 
            type="button" 
            className="buscar-btn" 
            onClick={handleSearch} 
            whileTap={{ scale: 0.95 }}
            transition={{ type: 'spring', stiffness: 500, damping: 20 }}>
              Buscar
          </motion.button>
      </div>
    </div>
  );
};

export default BuscarReservacion;
